import DefaultBuilder from './default-builder';
import TiersBuilder from './tiers-builder';
import BuilderInterface from 'components/organisms/players-to-exchange/available-players/builder-interface';
import PlayerBuilderInterface from 'components/organisms/players-to-exchange/available-players/player-builder-interface';

export default class BuilderFactory implements PlayerBuilderInterface {
    createClassicBuilder(sportConfig): BuilderInterface {
        return new DefaultBuilder(sportConfig);
    }

    createTiersBuilder(sportConfig): BuilderInterface {
        return new TiersBuilder(sportConfig);
    }

    createShowDownBuilder(sportConfig): BuilderInterface {
        return new DefaultBuilder(sportConfig);
    }

    createSingleGameBuilder(sportConfig): BuilderInterface {
        return new DefaultBuilder(sportConfig);
    }
}
